import React from "react";

const CampaignsReferral = () => {
  return <div>CampaignsReferral</div>;
};

export default CampaignsReferral;